<div class="component-container flex flex-col gap-[40px]">
  @if (changeOrderCreateMode !== 'auto' && canCreate) {
    <div class="flex justify-end mb-[20px]">
      <app-primary-button
        (handleClick)="openCreateDialog()"
        class="create-co-btn"
      >
        Create change order
      </app-primary-button>
    </div>
  }
  @if (dataSource?.length) {
    <div class="bit-items-table">
      <table [dataSource]="dataSource" class="mat-elevation-z8 table" mat-table>
        <ng-container matColumnDef="requestNo">
          <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Change order #'" class="text-type-6 !leading-[24px]" mat-header-cell>
            <span class="th-text">Change Order #</span>
            @if (selectedSortColumn === 'Change order #') {
              <span><mat-icon (click)="toggleSortDirection()" class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon></span>
            }
          </th>
          <td *matCellDef="let row" mat-cell>
            <div class="text-type-8">{{ row?.order_number }}</div>
            @if (row?.comments) {
              <div class="description text-type-14">{{ row.comments }}</div>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="amountChange">
          <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Amount change'" class="text-type-6 !leading-[24px]" mat-header-cell>
            <span class="th-text">Amount change</span>
            @if (selectedSortColumn === 'Amount change') {
              <span><mat-icon (click)="toggleSortDirection()" class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon></span>
            }
          </th>
          <td *matCellDef="let row" mat-cell>
            <div class="text-type-11">${{ row?.totalAmount | number : '1.2-2' }}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="workDayChange">
          <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Work days change'" class="text-type-6 !leading-[24px]" mat-header-cell>
            <span class="th-text">Work days change</span>
            @if (selectedSortColumn === 'Work days change') {
              <span><mat-icon (click)="toggleSortDirection()" class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon></span>
            }
          </th>
          <td *matCellDef="let row" mat-cell>
            <div class="text-type-11 location">{{ row?.totalWorkDaysChange }}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Status'" class="text-type-6 !leading-[24px]" mat-header-cell>
            <span class="th-text">Status</span>
            @if (selectedSortColumn === 'Status') {
              <span><mat-icon (click)="toggleSortDirection()" class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon></span>
            }
          </th>
          <td *matCellDef="let row" mat-cell>
            <div class="status-chip-container flex flex-col items-start gap-[4px]">
              <div
                [ngClass]="[statusMap?.[row?.status]?.bgColor || '', statusMap?.[row?.status]?.textColor || '']"
                class="status-chip px-[14px] rounded-full capitalize"
                >
                {{ statusMap?.[row?.status]?.label || row?.status || '-' }}
              </div>
              @if (row?.current_approver) {
                <div class="text-type-14 text-[#60698B]">
                  {{ row.current_approver.first_name }} {{ row.current_approver.last_name }}
                </div>
              }
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th *matHeaderCellDef class="text-type-6 !leading-[24px]" mat-header-cell></th>
          <td *matCellDef="let row" mat-cell>
            @if (shouldShowMenu(row)) {
              <div class="actions-container">
                <button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()" class="menu-button" mat-icon-button>
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  @if (row?.status === 'submitted') {
                    <button (click)="sendReminder(row, $event)" mat-menu-item>Send Reminder</button>
                  }
                  @if (row?.status === 'draft') {
                    <button (click)="deleteChangeOrder(row, $event)" mat-menu-item class="text-red-500">
                      <mat-icon svgIcon="trash" class="text-red-500"></mat-icon> Delete
                    </button>
                  }
                </mat-menu>
              </div>
            }
          </td>
        </ng-container>
        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr
          (click)="rowClicked(row)"
          *matRowDef="let row; columns: displayedColumns"
          [class.highlighted-row]="row === selectedRow"
          mat-row
        ></tr>
      </table>
    </div>
  }
  @if (!dataSource?.length) {
    <div class="no-data text-type-8 mt-[80px]">No data available.</div>
  }
  <app-paginator
    (pageChanged)="onPageChanged($event)"
    [itemsPerPage]="pagination?.pageSize"
    [maxVisiblePages]="5"
    [totalItems]="totalRecords"
    class="paginator"
    />
</div>
